var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarFullDate = function SvgCalendarFullDate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.65918,
    width: 22,
    height: 19.8,
    rx: 1.35,
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05 1.45898V5.85898",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9504 1.45898V5.85898",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 13.5593C12.9109 13.5593 13.6496 12.8205 13.6496 11.9093C13.6496 10.998 12.9109 10.2593 11.9996 10.2593C11.0883 10.2593 10.3496 10.998 10.3496 11.9093C10.3496 12.8205 11.0883 13.5593 11.9996 13.5593Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00059 13.5593C6.91186 13.5593 7.65059 12.8205 7.65059 11.9093C7.65059 10.998 6.91186 10.2593 6.00059 10.2593C5.08932 10.2593 4.35059 10.998 4.35059 11.9093C4.35059 12.8205 5.08932 13.5593 6.00059 13.5593Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0504 13.5593C18.9617 13.5593 19.7004 12.8205 19.7004 11.9093C19.7004 10.998 18.9617 10.2593 18.0504 10.2593C17.1391 10.2593 16.4004 10.998 16.4004 11.9093C16.4004 12.8205 17.1391 13.5593 18.0504 13.5593Z",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95029 19.6091C6.86156 19.6091 7.60029 18.8704 7.60029 17.9591C7.60029 17.0478 6.86156 16.3091 5.95029 16.3091C5.03902 16.3091 4.30029 17.0478 4.30029 17.9591C4.30029 18.8704 5.03902 19.6091 5.95029 19.6091Z",
    fill: "#0258FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 19.6091C12.9109 19.6091 13.6496 18.8704 13.6496 17.9591C13.6496 17.0478 12.9109 16.3091 11.9996 16.3091C11.0883 16.3091 10.3496 17.0478 10.3496 17.9591C10.3496 18.8704 11.0883 19.6091 11.9996 19.6091Z",
    fill: "#0258FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9151 19.6091C18.8264 19.6091 19.5651 18.8704 19.5651 17.9591C19.5651 17.0478 18.8264 16.3091 17.9151 16.3091C17.0039 16.3091 16.2651 17.0478 16.2651 17.9591C16.2651 18.8704 17.0039 19.6091 17.9151 19.6091Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarFullDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-full-date.e17cf3a0.svg";
export { ForwardRef as ReactComponent };